import { createApi } from '@reduxjs/toolkit/query/react'

import { TagTypes } from '../constants'

import baseQuery from './base-query'

export const emptyApi = createApi({
  reducerPath: 'identityApi',
  baseQuery: baseQuery(),
  tagTypes: TagTypes,
  endpoints: () => ({})
})
